module.exports = __webpack_public_path__ + "img/team-dark-06.d6de4f0f.jpg";